import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { ExportStatus, ReportExportStatus } from '../../../../../../../../core/api/lab.types';

export interface ExportReportButtonProps {
  exportResponse: ExportStatus | null;
  exportStatus: ReportExportStatus | string;
  downloadExport: () => void;
  createExport: (type: ReportExportStatus) => void;
  exportLoading: boolean;
  buttonType: ReportExportStatus;
  buttonCreateLabel: string;
  buttonDownloadLabel: string;
  buttonTestId: string;
  tooltip: string;
}

function ExportReportButton({
  exportResponse,
  exportStatus,
  downloadExport,
  createExport,
  exportLoading,
  buttonType,
  buttonCreateLabel,
  buttonDownloadLabel,
  buttonTestId,
  tooltip,
}: ExportReportButtonProps) {
  return (
    <Button
      title={tooltip}
      variant="contained"
      color="primary"
      size="xl"
      fullWidth
      style={{ minHeight: '207px' }}
      data-testid={buttonTestId}
      onClick={
        exportResponse?.exportLink && exportStatus === buttonType
          ? downloadExport
          : () => {
              createExport(buttonType);
            }
      }
    >
      <Box sx={{ minWidth: '110px' }} display="flex" justifyContent="center">
        {exportLoading && exportStatus === buttonType ? (
          <CircularProgress color="success" data-testid="export-loader" size={20} />
        ) : exportResponse?.exportLink && exportStatus === buttonType ? (
          buttonDownloadLabel
        ) : (
          buttonCreateLabel
        )}
      </Box>
    </Button>
  );
}

export default ExportReportButton;
